<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Laporan Performa Penjualan</div>
        <DataTable
          :value="items"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="30"
          :rowHover="true"
          :scrollable="true"
          :loading="loading"
          scrollDirection="horizontal"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col-3" style="margin-top: 2.2rem">
                <AutoComplete
                  class="p-col"
                  placeholder="Pilih Bulan"
                  :dropdown="true"
                  :suggestions="month_filtered"
                  v-model="month"
                  @complete="setMonth($event)"
                  field="name"
                  optionLabel="name"
                >
                  <template #item="slotProps">
                    <div class="p-col">
                      <div>{{ slotProps.item.name }}</div>
                    </div>
                  </template>
                </AutoComplete>
              </div>
              <div class="p-col-3" style="margin-top: 2.2rem">
                <AutoComplete
                  class="p-col"
                  placeholder="Pilih Tahun"
                  :dropdown="true"
                  :suggestions="year_filtered"
                  v-model="year"
                  @complete="setYear($event)"
                >
                  <template #item="slotProps">
                    <div class="p-col">
                      <div>{{ slotProps.item }}</div>
                    </div>
                  </template>
                </AutoComplete>
              </div>
              <div class="p-col-3" style="margin-top: 2.7rem">
                <Button
                  label="Cari"
                  class="p-button-primary"
                  icon="pi pi-search"
                  @click="getApi()"
                />
              </div>
              <div
                class="p-col"
                style="margin-top: 2.7rem"
                v-if="items != null"
              >
                <router-link
                  :to="{
                    name: 'print-sell-performance',
                    query: {
                      month: month.id,
                      year: year,
                      outlet_id: user.outlet_id
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading>Mengambil data barang. Mohon tunggu</template>
          <Column header="Kelompok Barang" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cat_code }}
              </div>
            </template>
          </Column>
          <Column header="Nama Barang" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cat_name }}
              </div>
            </template>
          </Column>
          <Column header="Barang Masuk" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.distribution_qty | number }}
              </div>
            </template>
          </Column>
          <Column header="Barang Refund" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.refund_inbound | number }}
              </div>
            </template>
          </Column>
          <Column header="Transfer Masuk" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.transfer_inbound_qty | number }}
              </div>
            </template>
          </Column>
          <Column header="Transfer Keluar" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.transfer_outbound_qty | number }}
              </div>
            </template>
          </Column>
          <Column header="Retur" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.outbound_qty | number }}
              </div>
            </template>
          </Column>
          <Column header="Transaksi" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.transaction_qty | number }}
              </div>
            </template>
          </Column>
          <Column header="Selisih Barang" headerStyle="text-align: center">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.diffirence_stock | number }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: false,
      items: null,
      month: null,
      month_filtered: null,
      today: new Date().toISOString().split('T')[0],
      months: [
        { id: '1', name: 'Januari' },
        { id: '2', name: 'Februari' },
        { id: '3', name: 'Maret' },
        { id: '4', name: 'April' },
        { id: '5', name: 'Mei' },
        { id: '6', name: 'Juni' },
        { id: '7', name: 'Juli' },
        { id: '8', name: 'Agustus' },
        { id: '9', name: 'September' },
        { id: '10', name: 'Oktober' },
        { id: '11', name: 'November' },
        { id: '12', name: 'Desember' }
      ],
      year: null,
      year_filtered: null,
      years: []
    }
  },
  mounted() {
    this.getAuthUser()
    this.getYears()
  },
  methods: {
    getAuthUser() {
      this.month = this.months[new Date().getMonth()]
      this.year = this.today.split('-')[0]
      this.getApi()
    },

    setMonth(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.month_filtered = [...this.months]
        } else {
          this.month_filtered = this.months.filter(item => {
            return item.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    getYears() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlet-inbound/listyear`)
        .then(response => {
          if (response.status === 200) {
            this.years = response.data.data.years
          }
        })
    },

    setYear(event) {
      this.year_filtered = this.years.filter(item => {
        return item.toString().startsWith(event.query.toString())
      })
    },

    getApi() {
      if (this.month == null || this.year == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Pilih bulan dan tahun terlebih dahulu',
          life: 3000
        })
        return
      }

      this.loading = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/report/sales-performance?month=${this.month.id}&year=${this.year}`
        )
        .then(response => {
          if (response.status === 200) {
            this.loading = false
            this.items = response.data.data.category
          } else {
            this.loading = false
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal mengambil data',
              life: 3000
            })
          }
        })
    }
  }
}
</script>
<style scoped>
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
